import { SelectOption } from '../data-table/models/SelectOption.model';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { MONTHS_ALL, MONTHS, BASE_YEAR } from '@shared/constants';

export interface IYearMonth {
  year: number;
  month: SelectOption;
}

@Component({
  selector: 'app-year-month-select',
  templateUrl: './year-month-select.component.html',
})
export class YearMonthSelectComponent {
  @Input() public years: number[] = Array.from(
    { length: new Date().getFullYear() + 1 - BASE_YEAR },
    (_, k) => BASE_YEAR + k
  );

  @Input() public selectedYear = this.years[0];

  @Input() public months = [MONTHS_ALL, ...MONTHS];

  @Input() public selectedMonth = this.months[0];

  @Input() public showMonth = true;

  @Output() yearMonthchanged = new EventEmitter<IYearMonth>();

  /**
   * Function to emit event when year or month is changed
   */
  onSelectionChange() {
    this.yearMonthchanged.emit({ year: this.selectedYear, month: this.selectedMonth });
  }
}
